export default function (store, { start, target, dropPosition }) {
    const expand = store.getState().drag?.expand;
    if (expand && store.getTask(target)?.collapsed) {
        store.in.exec("expand-task", { id: target });
    }
    const dragInfo = store.getState().dragInfo;
    store.setState({
        dragInfo: {
            ...dragInfo,
            start,
            target,
            dropPosition,
        },
    });
}
//# sourceMappingURL=drag.js.map